import { useQuery } from "@tanstack/react-query"

import {
  getLoad,
  listLoads,
  listPendingArrivals,
} from "@/features/intake/api/intake.api"
import type { LoadStatus } from "@/features/intake/api/types"

export const intakeKeys = {
  all: ["intake"] as const,
  pending: () => ["intake", "pending"] as const,
  loads: (status?: LoadStatus) =>
    status
      ? (["intake", "loads", status] as const)
      : (["intake", "loads"] as const),
  detail: (id: string | number) => ["intake", "detail", String(id)] as const,
}

export function usePendingArrivals() {
  return useQuery({
    queryKey: intakeKeys.pending(),
    queryFn: listPendingArrivals,
  })
}

export function useLoads(status?: LoadStatus) {
  return useQuery({
    queryKey: intakeKeys.loads(status),
    queryFn: () => listLoads(status),
  })
}

export function useLoad(loadId: string | number | undefined) {
  return useQuery({
    queryKey: intakeKeys.detail(loadId ?? ""),
    queryFn: () => getLoad(loadId as string | number),
    enabled: !!loadId,
  })
}
